import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby"; // Import Gatsby's Link component

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        Android apps empower you to claim real business disruption because it
        has the biggest share in the smartphone industry. Almost 71% of
        smartphone users own an Android-powered device. While all businesses are
        capitalizing on the platform’s user base, TekRevol’s{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development services
        </Link>{" "}
        can help you leverage easy entry to the Android market.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        iOS apps have the strongest user base that prioritizes app experience,
        one-touch functionality, and responsiveness. TekRevol has an edge{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iOS app development
        </Link>{" "}
        We offer apps that are functional and consistent in the interface. We
        create iOS apps powered by Objective C, Swift, and XCode – and use this
        stable yet dynamic, feature-rich trio conveniently for scaling iPhone
        and iPad apps.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        Games are forecasted to bring more revenue than other best-selling
        sectors in the entertainment industry. TekRevol’s{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game development services
        </Link>{" "}
        offer future-proof games with stunning graphics, high-end player
        experience, and ready monetization strategies. We use robust game
        development frameworks based on Unity and Unreal Engine.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description: (
      <>
        Our{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development services
        </Link>{" "}
        have the capability to create highly functional applications. TekRevol
        possesses the proficiency to provide effective digital solutions for
        both Android and iOS through Flutter. As a trusted{" "}
        <Link to="/" rel="noopener" aria-label="TekRevol">
          mobile app development company
        </Link>{" "}
        in San Diego, we understand how to craft the ideal app tailored to your
        needs.
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description: (
      <>
        Leveraging a well-established history in the healthcare sector,
        TekRevol’s{" "}
        <Link to="https://www.tekrevol.com/healthcare-app-development">
          healthcare development services
        </Link>
        can craft applications by blending their expertise with innovative
        solutions. Leveraging technologies such as telehealth, electronic health
        records (EHR), and AI-driven diagnostics, we propel healthcare
        institutions into a new era of digital excellence, fostering improved
        patient care and operational excellence.
      </>
    ),
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "TekRevol utilizes the potential of React Native to construct robust mobile applications for Android and iOS platforms, ensuring extensive functionality and delivering impeccable performance. Our skilled team is dedicated to creating apps that cater to your particular requirements and consistently provide an exceptional user experience across various devices and operating systems.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              TekRevol’s Scalable Mobile App Development Services in San Diego
            </h2>
            <p className="impro_para">
              We are a full-service app development company in San Diego with
              the finest development services covering a diverse range of
              industries. We have helped millions of clients get their dream
              mobile application, connecting them with their target audience.
              All of our skilled mobile app developers in San Diego are always
              on their toes to bring the most innovative app solution for you.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
